import {
  createThis2j2avj17cvnv2 as createThis,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { equals2v6cggk171b6e as equals_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { LazyThreadSafetyMode_NONE_getInstance2o5dw3dzszhgg as LazyThreadSafetyMode_NONE_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  trim11nh7r46at6sx as trim,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  toString336ienavfnzn0 as toString_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { substringiqarkczpya5m as substring } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HeaderValueParamClass;
function HeaderValueParam() {
  if (HeaderValueParamClass === VOID) {
    class $ {
      constructor(name, value, escapeValue) {
        return new.target.c51(name, value, escapeValue);
      }
      static c51(name, value, escapeValue) {
        var $this = createThis(this);
        $this.k4u_1 = name;
        $this.l4u_1 = value;
        $this.m4u_1 = escapeValue;
        return $this;
      }
      static u4w(name, value) {
        return this.c51(name, value, false);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof HeaderValueParam()) {
          tmp_0 = equals_0(other.k4u_1, this.k4u_1, true);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals_0(other.l4u_1, this.l4u_1, true);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = this.k4u_1.toLowerCase();
        var result = getStringHashCode(tmp$ret$0);
        var tmp = result;
        var tmp_0 = imul(31, result);
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = this.l4u_1.toLowerCase();
        result = tmp + (tmp_0 + getStringHashCode(tmp$ret$2) | 0) | 0;
        return result;
      }
      ze() {
        return this.k4u_1;
      }
      af() {
        return this.l4u_1;
      }
      toString() {
        return 'HeaderValueParam(name=' + this.k4u_1 + ', value=' + this.l4u_1 + ', escapeValue=' + this.m4u_1 + ')';
      }
    }
    initMetadataForClass($, 'HeaderValueParam');
    HeaderValueParamClass = $;
  }
  return HeaderValueParamClass;
}
var HeaderValueClass;
function HeaderValue() {
  if (HeaderValueClass === VOID) {
    class $ {
      constructor(value, params) {
        params = params === VOID ? emptyList() : params;
        this.t4u_1 = value;
        this.u4u_1 = params;
        var tmp = this;
        var tmp0 = this.u4u_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (element.k4u_1 === 'q') {
              tmp$ret$0 = element;
              break $l$block;
            }
          }
          tmp$ret$0 = null;
        }
        var tmp0_safe_receiver = tmp$ret$0;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l4u_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
        var tmp_0;
        if (tmp2_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          if (0.0 <= tmp2_safe_receiver ? tmp2_safe_receiver <= 1.0 : false) {
            tmp_1 = tmp2_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp3_elvis_lhs = tmp_0;
        tmp.v4u_1 = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
      }
      toString() {
        return 'HeaderValue(value=' + this.t4u_1 + ', params=' + toString(this.u4u_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.t4u_1);
        result = imul(result, 31) + hashCode(this.u4u_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HeaderValue()))
          return false;
        if (!(this.t4u_1 === other.t4u_1))
          return false;
        if (!equals(this.u4u_1, other.u4u_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HeaderValue');
    HeaderValueClass = $;
  }
  return HeaderValueClass;
}
function parseHeaderValue(text) {
  return parseHeaderValue_0(text, false);
}
function parseHeaderValue_0(text, parametersOnly) {
  if (text == null) {
    return emptyList();
  }
  var position = 0;
  var tmp = LazyThreadSafetyMode_NONE_getInstance();
  var items = lazy(tmp, parseHeaderValue$lambda);
  while (position <= get_lastIndex(text)) {
    position = parseHeaderValueItem(text, position, items, parametersOnly);
  }
  return valueOrEmpty(items);
}
function parseHeaderValueItem(text, start, items, parametersOnly) {
  var position = start;
  var tmp = LazyThreadSafetyMode_NONE_getInstance();
  var parameters = lazy(tmp, parseHeaderValueItem$lambda);
  var valueEnd = parametersOnly ? position : null;
  while (position <= get_lastIndex(text)) {
    var tmp0_subject = charCodeAt(text, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(44)) {
      var tmp_0 = items.n3();
      var tmp1_elvis_lhs = valueEnd;
      tmp_0.i2(new (HeaderValue())(subtrim(text, start, tmp1_elvis_lhs == null ? position : tmp1_elvis_lhs), valueOrEmpty(parameters)));
      return position + 1 | 0;
    } else if (tmp0_subject === _Char___init__impl__6a9atx(59)) {
      if (valueEnd == null)
        valueEnd = position;
      position = parseHeaderValueParameter(text, position + 1 | 0, parameters);
    } else {
      var tmp_1;
      if (parametersOnly) {
        tmp_1 = parseHeaderValueParameter(text, position, parameters);
      } else {
        tmp_1 = position + 1 | 0;
      }
      position = tmp_1;
    }
  }
  var tmp_2 = items.n3();
  var tmp2_elvis_lhs = valueEnd;
  tmp_2.i2(new (HeaderValue())(subtrim(text, start, tmp2_elvis_lhs == null ? position : tmp2_elvis_lhs), valueOrEmpty(parameters)));
  return position;
}
function valueOrEmpty(_this__u8e3s4) {
  return _this__u8e3s4.ht() ? _this__u8e3s4.n3() : emptyList();
}
function subtrim(_this__u8e3s4, start, end) {
  // Inline function 'kotlin.text.trim' call
  var this_0 = substring(_this__u8e3s4, start, end);
  return toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
}
function parseHeaderValueParameter(text, start, parameters) {
  var position = start;
  while (position <= get_lastIndex(text)) {
    var tmp0_subject = charCodeAt(text, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(61)) {
      var _destruct__k2r9zo = parseHeaderValueParameterValue(text, position + 1 | 0);
      var paramEnd = _destruct__k2r9zo.ze();
      var paramValue = _destruct__k2r9zo.af();
      parseHeaderValueParameter$addParam(parameters, text, start, position, paramValue);
      return paramEnd;
    } else if (tmp0_subject === _Char___init__impl__6a9atx(59) || tmp0_subject === _Char___init__impl__6a9atx(44)) {
      parseHeaderValueParameter$addParam(parameters, text, start, position, '');
      return position;
    } else {
      position = position + 1 | 0;
    }
  }
  parseHeaderValueParameter$addParam(parameters, text, start, position, '');
  return position;
}
function parseHeaderValueParameterValue(value, start) {
  if (value.length === start) {
    return to(start, '');
  }
  var position = start;
  if (charCodeAt(value, start) === _Char___init__impl__6a9atx(34)) {
    return parseHeaderValueParameterValueQuoted(value, position + 1 | 0);
  }
  while (position <= get_lastIndex(value)) {
    var tmp0_subject = charCodeAt(value, position);
    if (tmp0_subject === _Char___init__impl__6a9atx(59) || tmp0_subject === _Char___init__impl__6a9atx(44))
      return to(position, subtrim(value, start, position));
    else {
      position = position + 1 | 0;
    }
  }
  return to(position, subtrim(value, start, position));
}
function parseHeaderValueParameterValueQuoted(value, start) {
  var position = start;
  var builder = StringBuilder().l1();
  loop: while (position <= get_lastIndex(value)) {
    var currentChar = charCodeAt(value, position);
    if (currentChar === _Char___init__impl__6a9atx(34) && nextIsDelimiterOrEnd(value, position)) {
      return to(position + 1 | 0, builder.toString());
    } else if (currentChar === _Char___init__impl__6a9atx(92) && position < (get_lastIndex(value) - 2 | 0)) {
      builder.o1(charCodeAt(value, position + 1 | 0));
      position = position + 2 | 0;
      continue loop;
    }
    builder.o1(currentChar);
    position = position + 1 | 0;
  }
  var tmp = position;
  var tmp0 = _Char___init__impl__6a9atx(34);
  // Inline function 'kotlin.text.plus' call
  var other = builder.toString();
  var tmp$ret$0 = toString_0(tmp0) + other;
  return to(tmp, tmp$ret$0);
}
function nextIsDelimiterOrEnd(_this__u8e3s4, start) {
  var position = start + 1 | 0;
  loop: while (position < _this__u8e3s4.length && charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(32)) {
    position = position + 1 | 0;
  }
  return position === _this__u8e3s4.length || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(59) || charCodeAt(_this__u8e3s4, position) === _Char___init__impl__6a9atx(44);
}
function parseHeaderValue$lambda() {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList().p2();
}
function parseHeaderValueItem$lambda() {
  // Inline function 'kotlin.collections.arrayListOf' call
  return ArrayList().p2();
}
function parseHeaderValueParameter$addParam($parameters, text, start, end, value) {
  var name = subtrim(text, start, end);
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(name) === 0) {
    return Unit_instance;
  }
  $parameters.n3().i2(HeaderValueParam().u4w(name, value));
}
//region block: exports
export {
  HeaderValueParam as HeaderValueParam1kbqez3tb3lqp,
  parseHeaderValue as parseHeaderValuealpos28fgp6t,
};
//endregion

//# sourceMappingURL=HttpHeaderValueParser.mjs.map
